import { createTheme, ThemeProvider } from '@mui/material/styles';
import './App.css';
import { SnackbarProvider } from 'notistack';

import AppRoutes from './components/AppRoutes';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

// const theme = createTheme();
const theme = createTheme({
  typography: {
    fontFamily: ['San Francisco', 'serif'].join(','),
    lineHeight: 1.2,
    h1: {
      fontFamily: 'Area Inktrap',
      lineHeight: 1.1,
    },
    h2: {
      fontFamily: 'Area Inktrap',
      lineHeight: 1.1,
    },
    h3: {
      fontFamily: 'Area Inktrap',
      lineHeight: 1.1,
    },
    h4: {
      fontFamily: 'Area Inktrap',
      lineHeight: 1.1,
    },
    h5: {
      fontFamily: 'Area Inktrap',
      lineHeight: 1.1,
    },
    h6: {
      fontFamily: 'Area Inktrap',
      lineHeight: 1.1,
    },
    button: {
      fontWeight: 400,
    },
  },
  palette: {
    primary: {
      main: '#0C0C0C',
    },
    secondary: {
      main: '#FA7328',
    },
    error: {
      main: '#EC302F',
    },
    warning: {
      main: '#FFC107',
    },
    success: {
      main: '#117627',
    },
    greyDarkest: {
      main: '#404B59',
    },
    white: {
      main: '#ffffff',
    },
    blueSky: {
      main: '#00496D',
      contrastText: '#FFFFFF',
    },
    blueSkyLightest: {
      main: '#E6EDF0',
      contrastText: '#1C1F32',
    },
    greyLightest: '#F8F9FA',
    // Add your other colors here
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          maxWidth: '1440px',
        },
        maxWidthMd: {
          maxWidth: 320,
        },
        maxWidthLg: {
          maxWidth: '1536px!important',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 9999, // Set a large value to make the button fully rounded
          fontSize: '14px',
          padding: '10px 24px',
          fontWeight: 700,
          borderWidth: '1.5px',
        },
        sizeMedium: {
          fontSize: '12px',
          padding: '8px 14px',
        },
        // Small size button
        sizeSmall: {
          fontSize: '11px',
          padding: '6px 18px',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: 9999,
        },
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        contained: {
          boxShadow: 'none',
          borderRadius: '999px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          position: 'relative',
          boxShadow: 'none',
          // borderRadius: '12px',
          // border: 'solid 1px, #E6EDF0', // blueSkyLightest
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
        >
          <AppRoutes />
        </SnackbarProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
